// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"ForgotPassword_formContainer__S4IYD","primaryButton":"ForgotPassword_primaryButton__utuhW"};